// components/project/ProjectEconomicTab.js
// V1.1 — Wrapper Q.E. con 4 sotto-tab: Riepilogo | Entrate | Uscite | Analitico
// Step 2: Riepilogo con KPI reali. Analitico invariato. Entrate/Uscite placeholder (Step 3).

import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Calculator } from 'lucide-react';

import EconomicRiepilogoView from './economic/EconomicRiepilogoView';
import EconomicEntrateView from './economic/EconomicEntrateView';
import EconomicUsciteView from './economic/EconomicUsciteView';
import EconomicAnaliticoView from './economic/EconomicAnaliticoView';

const ProjectEconomicTab = ({ projectId, user, isAdmin, isAdministration }) => {
  // Default 'analitico' finché Entrate/Uscite non saranno operativi (Step 3).
  const [activeSubTab, setActiveSubTab] = useState('analitico');

  return (
    <div className="space-y-4" data-testid="project-economic-tab">
      {/* Header globale */}
      <div>
        <h3 className="text-h4 flex items-center gap-2">
          <Calculator className="w-5 h-5 text-purple-600" />
          Quadro Economico
        </h3>
        <p className="text-sm text-[#737373]">
          Controllo interno di costi, fornitori e marginalita del cantiere
        </p>
      </div>

      <Tabs value={activeSubTab} onValueChange={setActiveSubTab} className="space-y-4">
        <TabsList className="bg-white border border-[#DCDCDC]">
          <TabsTrigger value="riepilogo" data-testid="qe-subtab-riepilogo" className="data-[state=active]:bg-[#FF7819] data-[state=active]:text-white">
            Riepilogo
          </TabsTrigger>
          <TabsTrigger value="entrate" data-testid="qe-subtab-entrate" className="data-[state=active]:bg-[#FF7819] data-[state=active]:text-white">
            Entrate
          </TabsTrigger>
          <TabsTrigger value="uscite" data-testid="qe-subtab-uscite" className="data-[state=active]:bg-[#FF7819] data-[state=active]:text-white">
            Uscite
          </TabsTrigger>
          <TabsTrigger value="analitico" data-testid="qe-subtab-analitico" className="data-[state=active]:bg-[#FF7819] data-[state=active]:text-white">
            Analitico
          </TabsTrigger>
        </TabsList>

        <TabsContent value="riepilogo" data-testid="qe-tabcontent-riepilogo">
          <EconomicRiepilogoView projectId={projectId} onNavigate={setActiveSubTab} />
        </TabsContent>

        <TabsContent value="entrate" data-testid="qe-tabcontent-entrate">
          <EconomicEntrateView projectId={projectId} onNavigate={setActiveSubTab} />
        </TabsContent>

        <TabsContent value="uscite" data-testid="qe-tabcontent-uscite">
          <EconomicUsciteView projectId={projectId} onNavigate={setActiveSubTab} />
        </TabsContent>

        <TabsContent value="analitico" data-testid="qe-tabcontent-analitico" className="space-y-4">
          <EconomicAnaliticoView
            projectId={projectId}
            user={user}
            isAdmin={isAdmin}
            isAdministration={isAdministration}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ProjectEconomicTab;
